<template>
  <div>
    <dl class="prize">
      <dt>Total prize pool</dt>
      <dd>${{ prizeAmount }}</dd>
    </dl>
    <AuctionCard
      v-for="auction in auctions"
      :key="auction.id"
      :name="auction.name"
      :id="auction.id"
      :category="auction.category"
      :seed="auction.seed"
      :currentBid="auction.currentBid"
    />
  </div>
</template>

<script>
import { db } from "@/firebase";
import AuctionCard from "@/components/AuctionCard";

export default {
  name: "Auctions",
  components: {
    AuctionCard,
  },
  data() {
    return {
      auctions: [],
      currentUser: this.$store.getters.currentUser,
    };
  },
  computed: {
    prizeAmount() {
      var total = 0;
      for (var i = 0; i < this.auctions.length; i++) {
        if (this.auctions[i].currentBid) {
          total += this.auctions[i].currentBid;
        }
      }
      return total;
    },
  },
  methods: {
    getAuctions() {
      this.auctions = [];
      db.collection("auctions")
        .where("category", "==", "Womens")
        .orderBy("seed", "asc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.auctions.push({
              id: doc.id,
              name: doc.data().name,
              category: doc.data().category,
              seed: doc.data().seed,
              currentBid: doc.data().currentBid,
            });
          });
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
  },
  mounted() {
    this.getAuctions();
  },
};
</script>

<style scoped>
div {
  text-align: center;
}
img {
  width: 214px;
  margin: 24px auto;
}
</style>